import pick from 'lodash/pick';
import { PENDING } from 'utils/constants/queryStatuses';
import { getUserCountry, getUserPatientId } from 'modules/user/utils';
import { setKeyValue } from 'modules/keyValueStore/actions';
import CONSTANTS, { MATCH_FLOWS, PRESENTED_MATCHED_TRIALS_STORE_KEY } from './constants';
import { getMatches as getMatchesApi } from './api';
import { MatchFlow } from './matchFlow';
import { getMatchFlow } from './helpers';

function successMatches(result) {
  return { type: CONSTANTS.GET_MATCHES_SUCCESS, payload: result };
}

function failureMatches(error) {
  return { type: CONSTANTS.GET_MATCHES_FAILURE, payload: error };
}

const getMatches = ({ matchFlow = MATCH_FLOWS.LATEST, newest }) => async (dispatch, getState) => {
  const {
    profile: { data: profile },
    main: { lang },
  } = getState();
  dispatch({ type: CONSTANTS.GET_MATCHES_REQUEST });
  try {
    const result = await getMatchesApi({
      patientId: getUserPatientId(profile),
      ...pick((getUserCountry(profile) ?? {}).location ?? {}, ['lat', 'lng']),
      distance: profile.personal.travel_limit,
      lang,
      matchFlow,
      newest,
    });

    const {
      profile: { data: currentProfile },
    } = getState();
    dispatch(successMatches({
      ...result,
      profileUpdatedAt: currentProfile.personal?.profile_updated_at,
      ...(matchFlow === MATCH_FLOWS.BASIC ? { isStale: false } : {}),
    }));

    if (MatchFlow.getMatchFlow() === MATCH_FLOWS.BASIC && matchFlow === MATCH_FLOWS.BASIC) {
      MatchFlow.unsetMatchFlow();
    }
  } catch (ex) {
    console.error('getMatches: Error occurred, while getting matches:', ex);
    dispatch(failureMatches(`Error occurred, while getting matches: ${ex.message || ex}`));
  }
};

const requestMatches = ({ forceRematch, requestToRematch, newest }) => (dispatch, getState) => {
  const {
    matches: { status: matchesStatus, profileUpdatedAt: matchesProfileUpdatedAt },
    profile: { data: profile },
  } = getState();

  const { personal: { profile_created_at: profileCreatedAt, profile_updated_at: profileUpdatedAt } = {} } = profile;

  if (matchesStatus === PENDING) {
    // TODO TBD or abort previous
    return Promise.resolve();
  }
  if (!profileCreatedAt || !profileUpdatedAt) {
    // invariant
    return Promise.resolve();
  }

  let matchFlow;
  if (forceRematch) {
    matchFlow = MATCH_FLOWS.BASIC;
  } else {
    matchFlow = getMatchFlow({
      requestToRematch,
      profileCreatedAt,
      profileUpdatedAt,
      matchesProfileUpdatedAt,
    });
  }

  return dispatch(getMatches({ matchFlow, newest }));
};

const setMatchesIsStale = () => ({ type: CONSTANTS.SET_MATCHES_IS_STALE, payload: true });

const setPresentedMatchedTrials = (data) => setKeyValue(PRESENTED_MATCHED_TRIALS_STORE_KEY, data);

export const matchesActions = {
  requestMatches,
  getMatches,
  setPresentedMatchedTrials,
  setMatchesIsStale,
};
